import { makeStyles } from 'tss-react/mui'
import { FormattedMessage } from 'react-intl'
import { useWebOnlyPromoCountry } from '@src/utils/useUserCountry'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

const useStyles = makeStyles()((theme) => ({
  taxDisclaimer: {
    textTransform: 'uppercase',
  },
  priceDisclaimer: {
    fontStyle: 'italic',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
}))

interface PriceDisclaimerProps {
  countryCode: string
  hasDiscount?: boolean
  isBBE?: boolean
}

const PriceDisclaimer = ({
  countryCode,
  hasDiscount = false,
  isBBE = false,
}: PriceDisclaimerProps) => {
  const { classes, cx } = useStyles()
  const webOnlyCountries = useWebOnlyPromoCountry()
  const showWebOnlyPromotions =
    featureFlags.strikethroughPricing ||
    (!featureFlags.strikethroughPricing && webOnlyCountries)

  return (
    <>
      {countryCode.toLowerCase() === 'ar' && (
        <div className={cx(classes.priceDisclaimer, classes.taxDisclaimer)}>
          <FormattedMessage
            id="PRICE_WITHOUT_NATIONAL_TAXES"
            defaultMessage="PRICE WITHOUT NATIONAL TAXES"
          />
        </div>
      )}
      {hasDiscount && showWebOnlyPromotions && (
        <div className={classes.priceDisclaimer}>
          <FormattedMessage
            id="WEB_ONLY_PROMOTION"
            defaultMessage="Web-Only Promotion"
          />
        </div>
      )}
      {countryCode.toLowerCase() === 'cn' && isBBE && (
        <div className={cx(classes.priceDisclaimer, classes.taxDisclaimer)}>
          <FormattedMessage
            id="PRICE_EXCLUDES_TAX_AND_FREIGHT"
            defaultMessage="PRICE EXCLUDES TAX AND FREIGHT"
          />
        </div>
      )}
    </>
  )
}

export default PriceDisclaimer
